import { useDispatch } from 'hooks/utils';
import { useActivity } from 'hooks/store';
import { Operation } from 'hooks/store/types';
import { ActionTypes, deleteOrganization } from 'store/data/collaborators';

type HandlerInput = Parameters<typeof deleteOrganization>[0];

export function useDeleteOrganization(): Operation<(input: HandlerInput) => Promise<void>> {
	const dispatch = useDispatch();

	const [{ loading, error }, resetError] = useActivity(ActionTypes.DELETE_ORGANIZATION);

	async function handler(input: HandlerInput) {
		if (loading) return;
		if (error) resetError();

		await dispatch(deleteOrganization(input));
	}

	return [{ loading, error }, handler];
}
